import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/logocolor.svg";
import { Dropdown } from "flowbite-react";
import { useAuth } from "../contexts/AuthContext";
import { doSignOut } from "../database/auth";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Navbar = () => {
  // const { pathname } = useLocation();
  // if (pathname === "/login") return null;
  const { currentUser } = useAuth();
  const userRole = currentUser ? currentUser.rol : null;
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef();

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <section class="border-b border-gray-700/80">
      <nav class="bg-primary">
        <div class="max-w-screen-xl flex items-center justify-between mx-auto p-4">
          <div class="flex justify-between items-center space-x-12 rtl:space-x-reverse" ref={menuRef}>
            <Link
              to="/"
              class="flex items-center space-x-1 rtl:space-x-reverse"
              onClick={() => {
                // Limpia el almacenamiento local
                localStorage.removeItem("scrollTo");
              }}
            >
              <Logo class="h-12 w-12 animate-rotateLogo"></Logo>
              <span class="self-center text-[16px] whitespace-nowrap text-white">
                Rentable Inversor
              </span>
            </Link>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              data-collapse-toggle="navbar-default"
              type="button"
              class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="navbar-default"
              aria-expanded="false"
            >
              <span class="sr-only">Open main menu</span>
              <svg
                class="w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
            <div
              class={`${
                isMenuOpen ? "block" : "hidden"
              } absolute w-3/4 mt-[17rem] md:my-auto md:static md:w-auto my-auto md:flex`}
              id="navbar-default"
            >
              <ul class="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 dark:bg-primary bg-primary text-white">
                <li>
                  <Link
                    to="/"
                    onClick={(event) => {
                      // Guarda el ID de la sección en el almacenamiento local
                      localStorage.setItem("scrollTo", "#faq");
                      // Desplaza a la sección con el ID especificado
                      const element = document.getElementById("faq");
                      if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                    class="block w-full py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-bold text-white transition-all duration-200"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link
                    to="/"
                    onClick={(event) => {
                      // Guarda el ID de la sección en el almacenamiento local
                      localStorage.setItem("scrollTo", "#resultados");
                      // Desplaza a la sección con el ID especificado
                      const element = document.getElementById("resultados");
                      if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                    class="block w-full py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-bold text-white transition-all duration-200"
                  >
                    Resultados
                  </Link>
                </li>
                {!currentUser && (
                  <li>
                    <Link
                      to="/carrito"
                      class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-bold text-white transition-all duration-200"
                    >
                      Carrito
                    </Link>
                  </li>
                )}
                <li>
                  <div className="flex md:order-2">
                    <div className="flex md:order-2">
                      <Dropdown
                        className="bg-btngray text-white border-0 max-w-[200px]"
                        arrowIcon={true}
                        inline
                        label={
                          <label class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-bold text-white transition-all duration-200 hover:cursor-pointer">
                            Clases
                          </label>
                        }
                      >
                        <Link
                          to="/clases1"
                          className="flex text-white hover:bg-btngreen hover:shadow-lg hover:shadow-btngreen/25 w-full h-full py-3 px-4 text-start text-[14px] transition-all duration-200 rounded"
                        >
                          Entrenamiento Básico
                        </Link>
                        <Link
                          to="/clases2"
                          className="flex text-white hover:bg-btngreen hover:shadow-lg hover:shadow-btngreen/25 w-full h-full py-3 px-4 text-start text-[14px] transition-all duration-200 rounded"
                        >
                          Entrenamiento Avanzado
                        </Link>
                      </Dropdown>
                    </div>
                  </div>
                </li>
                {currentUser && (
                  <li>
                    <Link
                      to="/alumno"
                      class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-bold text-white transition-all duration-200"
                    >
                      Alumno
                    </Link>
                  </li>
                )}
                {userRole === "admin" && (
                  <li>
                    <Link
                      to="/admin"
                      class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent font-bold text-white transition-all duration-200"
                    >
                      Admin
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {!currentUser && (
            <div class="flex flex-col items-center space-x-2 space-y-2 md:space-y-0 md:space-x-0 md:space-x-4 md:flex-row">
              <Link to="/login">
                <button class="btn bg-btngray rounded-lg text-white font-bold text-base p-1 ml-2 md:py-2 md:px-6 md:py-5 md:px-8 mr-2 whitespace-nowrap shadow-btn-shadow shadow-btngray/25 transition duration-200 ease-in-out hover:shadow hover:shadow-btngray/50 hover:bg-gray-700">
                  Iniciar Sesion
                </button>
              </Link>
              <Link to="/clases1">
                <button class="btn bg-btngreen rounded-lg text-white font-bold text-base py-1 px-3 ml-2 md:py-5 md:px-7 md:py-4 md:px-8 mr-2 ml-auto shadow-btn-shadow shadow-btngreen/25 transition duration-200 ease-in-out hover:shadow hover:shadow-btngreen/50 hover:bg-green-700">
                  Registrarse
                </button>
              </Link>
            </div>
          )}
          {currentUser && (
            <div
              onClick={() => {
                Swal.fire({
                  title: "¿Quieres cerrar sesion?",
                  icon: "warning",
                  showCancelButton: true,
                }).then((result) => {
                  if (result.isConfirmed) {
                    doSignOut();
                    navigate("/login", { replace: true });
                  }
                });
              }}
              class="block bg-btngray rounded-lg py-4 px-4 cursor-pointer ml-2 shadow-btn-shadow shadow-btngray/25"
            >
              <svg
                class="w-6 h-6 text-gray-800 text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
                />
              </svg>
            </div>
          )}
        </div>
      </nav>
    </section>
  );
};

export default Navbar;
